import {IconCircleX} from "@tabler/icons-react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import styles from "./WithdrawalResult.module.css";

const WithdrawalFailure = ({errorMessage, onRetry, onClose}) => {
  const {t} = useTranslation();

  return (
    <div className={styles.resultContainer}>
      <div className={styles.iconWrapper}>
        <IconCircleX
          size={68}
          color="var(--status-error)"
          fill="var(--status-error)"
          stroke="var(--bg-main)"
        />
      </div>

      <h2 className={styles.resultTitle}>{t("withdrawalFailureTitle")}</h2>

      <p className={styles.resultMessage}>{t("withdrawalFailureMessage")}</p>

      {errorMessage && <p className={styles.errorDetail}>{errorMessage}</p>}

      <div className={styles.buttonRow}>
        <PrimaryButton
          size="lg"
          onClick={onRetry}
        >
          {t("withdrawalFailureRetry")}
        </PrimaryButton>

        <SecondaryButton
          size="lg"
          onClick={onClose}
        >
          {t("withdrawalFailureClose")}
        </SecondaryButton>
      </div>
    </div>
  );
};

WithdrawalFailure.propTypes = {
  errorMessage: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WithdrawalFailure;
